import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import OrderConstant from "../../constants/OrderConstant";
import {
  getAllUserOrders as getAllUserOrdersAction,
  updateOrder as updateOrderAction,
  addOrder as addOrderAction,
  doneOrder as doneOrderAction,
} from "../../redux/modules/order";
import {
  getDealComments as getDealCommentsAction,
  addComment as addCommentAction,
} from "../../redux/modules/comment";
import { getDealLogs as getDealLogsAction } from "../../redux/modules/logs";
import {
  filterUser as filterUserAction,
  getWorkers as getWorkersAction,
} from "../../redux/modules/login";
import { getUsersByPhone as getUsersByPhoneAction } from "../../redux/modules/users";
 
import { formatDateDMY, formatDateHM } from "../../utilities/date"
import { numberWithCommas } from "../../utilities/numbers";
import { toArrayClearList, inArrayValueByKey } from "../../utilities/array";

import UiInputSearch from "../../components/inputs/UiInputSearch";
import UiBoard from "../../components/board/UiBoard";
import UiButtonColor from "../../components/button/UiButtonColor";
import UiModalDealAdd from "../../components/modals/UiModalDealAdd";
import UiPageText from "../../components/text/UiPageText";
import UiTableAdaptive from "../../components/table/UiTableAdaptive";

import "./HomeStyle.scss";

function HomePage(props) {
  const [searchLine, setSearchLine] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [modalDealAddACtive, setModalDealAddActive] = useState(false);

  const clientsTitles = [
    { sort: false, title: "" },
    { sort: true, title: "Дата и\nвремя" },
    { sort: true, title: "Номер" },
    { sort: false, title: "Покупатель" },
    { sort: false, title: "Состав" },
    { sort: true, title: "Статус\nзаказа" },
    { sort: true, title: "Сумма" },
    { sort: false, title: "Оплата" },

    { sort: false, title: "Курьер" },
    { sort: false, title: "Дата\nдоставки" },
    { sort: false, title: "Адрес\nдоставки" },
    { sort: false, title: "Комментарий" },
    { sort: false, title: "Тип\nоплаты" },
  ];
  const [tableListOrders, setTableListOrders] = useState([]);
  const newOrder = {
    isNew: true,
    status: 0,
    price: 0,
    payment_type: 0,
    moving_types: 0,
    distance: 1,
    is_pay: 0,
    order_type: 0,
    type: 0,
    composition: "",
    photos: "",
    user_phone: "",
    phone: "",
    name: "",
    date: "",
    time: "",
    order_name: "",
    address_a: "",
    elevator_type_a: 0,
    floor_a: "",
    text: "",
  }

  useEffect(() => {
    if (props.login.user) {
      props.getAllUserOrders();
      props.getWorkers(); 
    }
  }, [props.login.user]);

  useEffect(() => {
    if (props.order.ordersList) {
      let arr = [];
      props.order.ordersList.map((item) => {
        arr.push([
          {
            button: "edit", openClick: () => {
              setModalDealAddActive(true)
              setSelectedData(item);
            }
          },
          { text: `${formatDateDMY(item.created_at)}  ${formatDateHM(item.created_at)}` },
          { text: `${item.id}` },
          { text: `${item.name ? item.name : ""} +${item.phone}` },
          { text: "Название букета" },
          {
            statusInfo: OrderConstant.ORDER_TYPES_NAMES[item.status],
            statusColor: OrderConstant.ORDER_TYPES_COLORS[item.status],
            statusList: OrderConstant.ORDER_TYPES_NAMES,
            onStatusChange: (val) => {
              let _item = item;
              _item.status = val;
              props.updateOrder(_item, OrderConstant.UPDATE_INFO_CHANGE_INFO);
            }
          },

          { text: `${numberWithCommas(item.price)} ₽` },
          {

            payStatus: item.is_pay
              == 0 ? "wait" : "done",
            statusPayList: OrderConstant.ORDER_IS_PAY,
            onStatusPayChange: (val) => {
              let _item = item;
              _item.is_pay = val;
              props.updateOrder(_item, OrderConstant.UPDATE_INFO_CHANGE_INFO);
            }
          },
          {
            curInfo:
              `${inArrayValueByKey(props.login.usersWorker, "id", item.worker_id) ?
                inArrayValueByKey(props.login.usersWorker, "id", item.worker_id).name :
                "== || =="}`,
            curList: toArrayClearList(props.login.usersWorker, "name"),
            onCurChange: (val) => {
              let _item = item;
              _item.worker_id = val;
              props.updateOrder(_item, OrderConstant.UPDATE_INFO_CHANGE_INFO);
            }

          },
          { text: `${(item.date)}  ${(item.time)}` },
          { text: `${item.address_a}` },
          { text: item.text ? item.text : "-" },
          { text: OrderConstant.ORDER_PAYMENTS_TYPES_NAMES[item.payment_type] },
        ])
      })
      setTableListOrders(arr)
    }
  }, [props.order.ordersList]);

  return (
    <div id="page" className="home-page">
      <section className="home-info ui-grid">
        <div className="home-info-text">
          <UiPageText title="Заказы" />
        </div>
        <div className="home-info-button">
          <UiButtonColor
            color="primary"
            text="Новый заказ"
            small={true}
            onClick={() => { 
              setModalDealAddActive(true)
              setSelectedData(newOrder)
            }}
          />
        </div>
      </section>
      <section className="page-content">
        <div className="page-search">
          <UiInputSearch
            label="Список пользователей"
            placeholder="Поиск: Номер заказа или телефон"
            onChange={(val) => setSearchLine(val)}
          />
        </div>
        <UiTableAdaptive
          titleList={clientsTitles}
          grid={clientsTitles.length}
          tableList={tableListOrders}
          search={searchLine}
        />

        {/*<UiBoard
          list={props.order ? props.order.ordersList : []}
          comments={props.comment.commentsList ? props.comment.commentsList : []}
          logs={props.logs.logsList ? props.logs.logsList : []}
          workers={props.login.usersWorker ? props.login.usersWorker : []}
          onChangeStatus={(item, status) => {
            let _item = item;
            _item.status = status;
            //done deal
            if (status == OrderConstant.ORDER_STATUS_DONE) {
              props.doneOrder({ deal_id: item.id, worker_id: item.worker_id, user_id: item.user_id })
            } else {
              props.updateOrder(_item, OrderConstant.UPDATE_INFO_NEW_STATUS)

            }

          }}
          onChangeDealWorker={(item, wid) => {
            let _item = item;
            _item.worker_id = wid;
            props.updateOrder(_item, OrderConstant.UPDATE_INFO_NEW_WORKER);
            props.getWorkers();
            props.getDealLogs(_item.id);
          }}
          onRequestDeal={(id) => {
            props.getDealComments(id);
            props.getDealLogs(id);
          }}
          onAddComment={(data) => props.addComment(data)}
          onChangeDealPrice={(item, price) => {
            let _item = item;
            _item.price = price;
            props.updateOrder(_item, OrderConstant.UPDATE_INFO_CHANGE_PRICE);
            props.getDealLogs(_item.id);
          }}
          onChangeDealText={(item, text) => {
            let _item = item;
            _item.text = text;
            props.updateOrder(_item, OrderConstant.UPDATE_INFO_CHANGE_INFO);
            props.getDealLogs(_item.id);
          }}
        />*/}
      </section>
      {/* modal deal add */}
      <UiModalDealAdd
        data={selectedData}
        modalActive={modalDealAddACtive}
        modalClose={() => setModalDealAddActive(false)}
        findUserEvent={props.getUsersByPhone}
        prices={props.settings.prices}
        onCreate={(data) => {
          props.addOrder(data).then(() => {
            setModalDealAddActive(false);
          });
        }}

        update={(data) => {
          props.updateOrder(data, OrderConstant.UPDATE_INFO_CHANGE_INFO).then(() => {
            setModalDealAddActive(false);
          });
        }}
      />
    </div>
  );
}

export default connect(
  ({ order, login, comment, logs, user, settings }) => ({
    order,
    login,
    comment,
    logs,
    user,
    settings,
  }),
  {
    getAllUserOrders: getAllUserOrdersAction,
    updateOrder: updateOrderAction,
    addOrder: addOrderAction,
    doneOrder: doneOrderAction,
    getDealComments: getDealCommentsAction,
    addComment: addCommentAction,
    getDealLogs: getDealLogsAction,
    filterUser: filterUserAction,
    getWorkers: getWorkersAction,
    getUsersByPhone: getUsersByPhoneAction,
 
  }
)(HomePage);
